// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormImageUploader_wrapper__mU8xQ","editButton":"FormImageUploader_editButton__EWJBu"};